import React from "react";
import { Link } from "react-router-dom";
import BricknBarLogo from "../../assets/NavLogo/BNBLOGO.png";
import { Mail, Phone, MapPin } from "lucide-react";
import TopBar from "./Footer/TopBar";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { FaCcVisa, FaCcMastercard, FaCcApplePay, FaLock } from "react-icons/fa";
import { SiDiscover } from "react-icons/si";

const Footer = () => {
  return (
    <footer className="bg-gray-50 text-black">
      <TopBar />

      <div className="container mx-auto px-4 lg:px-8 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-4">
              <img src={BricknBarLogo} alt="BricknBar Logo" className="h-20" />
            </Link>
            <p className="text-gray-700 mt-2 mb-3">
              BricknBar, founded in 2019 by Brahmananda Nahak, has quickly
              emerged as a trusted name in the construction industry. With a
              passion for excellence and a commitment to customer satisfaction,
              we specialize in high-quality construction materials online.
            </p>
            <div className="mt-3 space-x-2 flex justify-start md:items-center flex-col md:flex-row items-start">
              <p className="flex items-start">
                <Phone size={18} className="text-orange-500 mr-3 mt-1" />
                <span className="text-gray-700 border-b-2 border-red-900 pb-[1px]">
                  +91(9777)772-782
                </span>
              </p>
              <p className="text-gray-500 text-center">or</p>
              <p className="flex items-start">
                <Mail size={18} className="text-orange-500 mr-3 mt-1" />
                <span className="text-gray-700 border-b-2 border-red-900 pb-[1px]">
                  bricknbar1@gmail.com
                </span>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="font-bold text-lg mb-4 relative">
              <span className="after:content-[''] after:absolute after:w-12 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                My Account
              </span>
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <Link
                  to="/profile"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> My Account
                </Link>
              </li>
              <li>
                <Link
                  to="/orders"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Order History
                </Link>
              </li>
              <li>
                <Link
                  to="/all-cart-product"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Shopping Cart
                </Link>
              </li>
              <li>
                <Link
                  to="/wishlist"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Wishlist
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div className="lg:col-span-2">
            <h4 className="font-bold text-lg mb-4 relative">
              <span className="after:content-[''] after:absolute after:w-6 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                Help
              </span>
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <Link
                  to="/addresses"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Addresses
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> FAQs
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-condition"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="font-bold text-lg mb-4 relative">
              <span className="after:content-[''] after:absolute after:w-6 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                Proxy
              </span>
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <Link
                  to="/comparision"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Compare
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Products
                </Link>
              </li>
              <li>
                <Link
                  to="/orders"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="text-gray-700 hover:text-orange-500 transition duration-300 flex items-center"
                >
                  <span className="mr-2">›</span> Track Order
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <div className="mb-6 md:mb-0">
              <h4 className="font-bold text-lg mb-4">
                Download Our Mobile App
              </h4>
              <div className="space-y-4">
                <Link
                  to="#"
                  className="flex items-center px-4 py-2 bg-white rounded-xl shadow-md hover:shadow-lg transition border"
                >
                  <FaApple className="text-3xl mr-3" />
                  <div className="text-left leading-tight">
                    <p className="text-xs">Download on the</p>
                    <p className="text-sm font-semibold">App Store</p>
                  </div>
                </Link>
                <Link
                  to="#"
                  className="flex items-center px-4 py-2 bg-white rounded-xl shadow-md hover:shadow-lg transition border"
                >
                  <FaGooglePlay className="text-2xl mr-3" />
                  <div className="text-left leading-tight">
                    <p className="text-xs">Download on the</p>
                    <p className="text-sm font-semibold">Google play</p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile App Section */}
        <div className="mt-4 border-t border-gray-800 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div>
              {/* © {new Date().getFullYear()}{" "}
              <span className="font-semibold text-orange-500">BricknBar</span> -
              All Rights Reserved */}
            </div>
            <div className="flex flex-col items-end">
              {/* <div className="text-sm text-gray-700">
                Secure Payment Options
              </div> */}
              <div className="flex space-x-3 mt-2">
                <div className="  flex items-center justify-center">
                  <FaCcApplePay className="text-black" size={50} />
                </div>
                <div className="  flex items-center justify-center">
                  <FaCcVisa className="text-2xl text-blue-700" size={50} />
                </div>
                <div className="flex items-center justify-center">
                  <SiDiscover className="text-2xl text-orange-600" size={50} />
                </div>
                {/* <div className="  flex items-center space-x-1">
                  <FaLock className="text-lg text-gray-700" size={30} />
                  <span className="text-sm font-semibold text-gray-700">
                    Secure Payment
                  </span>
                </div> */}
                <div className="  flex items-center justify-center">
                  <FaCcMastercard className="text-2xl text-red-600" size={50} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-300">
        <div className="container mx-auto px-4 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-700 text-sm">
            <div>
              © {new Date().getFullYear()}{" "}
              <span className="font-semibold text-orange-500">BricknBar</span> -
              All Rights Reserved
            </div>
            <div>
              Design & Developed by{" "}
              <Link
                to="#"
                className="text-orange-500 hover:text-orange-700 font-medium transition duration-300"
              >
                Web-Bocket
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
